// extracted by mini-css-extract-plugin
export default {"removeTagBtn":"app-react-components-TagButton-TagButton-module__remove-tag-btn"};